// src/components/BannerWithCard_DAO.js
import React from 'react';
import styled from 'styled-components';

const BannerContainer = styled.div`
  position: relative;
  padding: 4% 0px 0px 0px;
  background-color: #000000;
  text-align: center;
  max-width: 100%;

  img {
    max-width: 100%; /* 調整圖片最大寬度 */
    height: auto; /* 確保高度按比例縮放 */
  }

  h1 {
    position: absolute;
    top: 25%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 52px;
    line-height: 75px;
    font-weight: 700;
    letter-spacing: 0.05em;
    color: #FFFFFF;
  }

  .overlay {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 50%;
    height: 50%;
    background: rgba(0, 0, 0, 0.9);
    box-shadow: 0px 0px 20px rgba(182, 176, 95, 0.4);
    border-radius: 30px 30px 0px 0px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    
  }

  .title {
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 700;
    font-size: 30px;
    line-height: 43px;
    letter-spacing: 0.05em;
    color: #FFF56A;
    padding: 0% 0% 0% 5%;
  }

  .description {
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 32px;
    color: #EFEFEF;
    
    padding: 2.5% 5% 0% 5%;
    text-align: left;
  }

  @media (max-width: 500px) {
    padding: 2% 0px 50% 0px;

    h1 {
      font-size: 36px;
      line-height: 52px;
      width:90%;
      
    }

    .overlay{
      left: 50%;
      width: 90%;
      height: 50%;


    }

    .title {
      font-size: 20px;
      line-height: 29px;
      padding: 10% 0% 0% 5%;
      

    }

    .description {
      font-size: 14px;
      line-height: 24px;
      padding-bottom:10%;
    }
  }
`;

const DesktopBanner = styled.img`
  display: block;

  @media (max-width: 500px) {
    display: none;
  }
`;

const MobileBanner = styled.img`
  display: none;
  width: 100%;
  
  @media (max-width: 500px) {
    display: block;

    
  }
`;

const BannerWithCard_DAO = () => (
  <BannerContainer>
    <DesktopBanner src="/images/pages_banner.png" alt="Desktop Banner" />
    <MobileBanner src="/images/pages_banner_mobile.png" alt="Mobile Banner" />
    <h1>web3 發展建議</h1>
    <div className="overlay">
      <div className="title">web3 是甚麼？</div>
      <div className="description">
        web3 Foundation 在其官網上定義著：”Web 3.0, a decentralized and fair internet where users control their own data, identity and destiny.” （中譯：『web 3.0 是去中心化且公平公正的網際網路，使用者能夠掌握自己的資料、身分和命運』
      </div>
    </div>
  </BannerContainer>
);

export default BannerWithCard_DAO;
